import React from "react";
import * as Styled from "./Style";

const BillingOptions = (props) => {
  return (
    <Styled.BillingOptionsStyle className={props.data.orderDetailsHasValue ? "enabled" : "disabled"}>
      <div>
        <input
          type="radio"
          key={Math.random()}
          name="billingAddressOptions"
          value="sameAsDelivery"
          id="sameAsDelivery"
          className="billing-radio"
          disabled={!props.data.orderDetailsHasValue}
          checked={props.data.isBillingRadioSameClicked}
          onChange={props.billingRadioChange}
          onClick={props.closeAddressModalHandler}
        />
        <label htmlFor="sameAsDelivery">Same as delivery address</label>
      </div>
      <div>
        <input
          type="radio"
          key={Math.random()}
          name="billingAddressOptions"
          value="otherBillingAddress"
          id="otherBillingAddress"
          className="billing-radio"
          disabled={!props.data.orderDetailsHasValue}
          checked={props.data.isBillingRadioDifferentClicked}
          onChange={props.billingRadioChange}
        />
        <label htmlFor="otherBillingAddress">Use a different billing address</label>
      </div>
    </Styled.BillingOptionsStyle>
  );
};

export default BillingOptions;
